import { SubjectRoles } from "@/api-schema-enums";
import { getFirstNavigationUrl } from "@/common/helpers/navigation";
import { findBestMatchingNavigationItemByPath } from "@/common/helpers/route";
import type { NavigationItem } from "@/config/navigation/types";
import { userStore } from "@/store/user-store";
import { useStore } from "zustand";

const EMPTY_ROLES: SubjectRoles[] = [];

export const useExternalRootPath = (routeConfig: NavigationItem[]): string => {
  const roles = useStore(userStore, (state) => state.user?.roles ?? EMPTY_ROLES);

  // Fallback to route users to "/" if they have both INT and EXT Roles (Developers)
  if (roles.includes(SubjectRoles.Int)) return "/";

  const preferredPath = roles.includes(SubjectRoles.FitExtAdministrator) ? "/fit/relocation-request" : "/fit/load";

  if (findBestMatchingNavigationItemByPath(routeConfig, preferredPath)) {
    return preferredPath;
  }

  return getFirstAvailableExternalPath(routeConfig) ?? preferredPath;
};

function getFirstAvailableExternalPath(routeConfig: NavigationItem[]): string | undefined {
  const fitModule = routeConfig.find((item) => item.id === "fit-external" || item.id === "fit");
  const fitUrl = getFirstNavigationUrl(fitModule);
  if (fitUrl) return fitUrl;

  for (const item of routeConfig) {
    const url = getFirstNavigationUrl(item);
    if (url) return url;
  }

  return undefined;
}
